module.exports = __webpack_public_path__ + "static/media/white_thumb.d1a25584.svg";